import React, { useState } from "react";
import { Text } from "../containers/Language";
import styled from "styled-components";
import "../Css/Refugees.css";
import {Link} from "react-router-dom"
const Styles = styled.div`
  padding: 10px;
`;

function SportParalymics() {
  return (
    <div className="sepNav">
      <h1 className="titleh1">
        {" "}
        <Link to="/">
          <Text tid="Refugees_title" />
        </Link>
      </h1>
      <img
        src="https://img.freepik.com/free-photo/women-hand-chain-link-fence_61573-2824.jpg?size=626&ext=jpg"
        alt="worldcom_pic"
      />

      {/* history part */}
      <div className="row1">
        <div
          className="_ref_history col-xs-10 col-sm-8 col-md-10"
          style={{ paddingBottom: "100px" }}
        >
          <h1 className="H1_ref">
            {" "}
            <a href="#">
            <Text tid="Refugees_second_title" />
            </a>
          </h1>

          <p className="text-justify">
          <Text tid="Refugees_paragraph" />

            <br />
          </p>

          <hr style={{ paddingTop: "1px", borderTop: "1px solid black" }}></hr>
        </div>
      </div>

      {/* ///////////////////////////////////////////////// */}

      <div className="row1">
        <div className="_ref_history col-xs-10 col-sm-10 col-md-10">
          <h1 className="H1_ref">
            <a href="#">
       <Text tid="Refugees_3th_title" />
            </a>
          </h1>
          <h3 className="h3_target">
          <Text tid="Refugees_4th_title_" />

        
          </h3>
          <p className="text-justify">
          <Text tid="Refugees_3th_paragraph" />

          </p>

        </div>
      </div>
    </div>
  );
}

export default SportParalymics;
